module.exports = __webpack_public_path__ + "static/media/International_Beneficiary.982c5195.svg";